/**
 * Created by Amit Panghal
 */

import {TimelineLite, Timeline} from "gsap";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {DirtyWilds} from "../DirtyWilds";
import {ZeroBetManager} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetManager";
import {ScreenManager} from "@nolimitcity/slot-game/bin/core/screen/ScreenManager";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {IBetLineWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {StateMatrix} from "../../utils/StateMatrix";
import {SymbolUtil} from "../../utils/SymbolUtil";
import {DirtyWildsGameConfig} from "../DirtyWildsGameConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {DirtyWildsReelController} from "../reel/DirtyWildsReelController";
import {DirtyWildsModeData} from "../server/data/DirtyWildsModeData";
import {DirtyWildGameMode} from "../features/DirtyWildsRespinZeroBetController";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";

export class DirtyWildsSpinController extends SpinController {
    protected _betWinsData:IBetWinData[] | null;
    protected _movedToSpinLayer:boolean;

    constructor() {
        super();
    }

    public isQuickStop():boolean {
        return this._isQuickStop || false;
    }

// extra this function out for the game which need to do some feature before the spin really start. the feature handling might be added to the framework in the feature.
    protected startSpin():void {
        if(this._betWinsData) {
            const winSymbolsFromLeft:StateMatrix<string> = SymbolUtil.createSymbolStateMatrixFromBetWinsBeforeSpin(<IBetLineWinData[]>this._betWinsData!);
            const winSymbolsLeft = SymbolUtil.getSymbolsWithStatePerReel(winSymbolsFromLeft, DirtyWildsGameConfig.instance.SYMBOL_STATES.win.keyword);
            let symbolsInReel = new TimelineLite();
            for(let i:number = 0; i < winSymbolsLeft.length; i++) {
                let reelWinAnimations:Timeline[] = SymbolUtil.getSymbolStateAnimations(winSymbolsLeft[i], DirtyWildsGameConfig.instance.SYMBOL_STATES.noWin, 0.0);
                symbolsInReel.add(reelWinAnimations, 0);
            }
            EventHandler.dispatchEvent(new GameEvent(DirtyWildsReelController.ADD_SPIN_START_DELAY, 0, symbolsInReel.totalDuration()));
        }
        super.startSpin();
    }

    protected getSpinTime():number {
        const spinTime:number = DirtyWildsModeData.instance.mode == DirtyWildGameMode.STICKY_RESPIN ? DirtyWildsGameConfig.instance.RESPIN_SPIN_TIME : GameConfig.instance.REEL_SPIN_TIME;

        if(this._isZeroBet) {
            return spinTime;
        }

        return Math.max(spinTime, SpinController.MIN_SPIN_TIME);
    }

    protected onAllReelsSpinStarted():void {
        // Tells the api
        this.addStopDelay(this.getSpinTime());
        this.onSpinTimerDone();
    }

    protected parseGameData(data:ParsedGameData):void {
        this._betWinsData = data.betWins;
    }
}